<template>
  <div class="other-link">
    <i class="i-icon logoIcon"></i>
    <a-alert class="alert-box" :message="ONLINE_URL" description="移动端请复制链接到pc端打开" type="warning" />
  </div>
</template>

<script>
import { ONLINE_URL } from '@/config/url';
export default {
  name: "warningroot",
  data() {
    return {
      user: null,
      ONLINE_URL: ONLINE_URL
    }
  },
  async mounted() {
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
@import "./warning.scss";
</style>